import { HTTP } from '@/http';

export function getSummary(mt4Account) {
  return HTTP.get(`mt4/` + mt4Account.accountType.mT4Server.mT4ServerId +  `/summary/` + mt4Account.login);
};

export function getUserRecord(mt4Account) {
  return new Promise((resolve, reject) => {
    HTTP.get(`mt4/` + mt4Account.accountType.mT4Server.mT4ServerId + `/` + mt4Account.login).then(response => {
      resolve(response);
    }, error => {
      reject(error);
    })
  });
};



// WEBPACK FOOTER //
// ./src/services/MT4Service.js